import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../common/models/Error";
import { DashboardState } from "../models/DashboardState";

const setError = (state: DashboardState, action: PayloadAction<Error>) => {
    state.isError = action.payload.error;
    state.isLoading = false;
}

export default setError;